const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'Dowód rejestracyjny pojazdu',
	'vehicleRegistrationDocument.description':
		'Dodaj wyraźne zdjęcia wymaganych stron dowodu rejestracyjnego.',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'Przód dowodu rejestracyjnego',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Zrób wyraźne zdjęcie przodu dowodu rejestracyjnego.',
	'vehicleRegistrationDocument.RegistrationDocument.headline': 'Przód dowodu rejestracyjnego',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'Przód dowodu rejestracyjnego - przykład',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'Przód dowodu rejestracyjnego',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title': 'Tył dowodu rejestracyjnego',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Zrób wyraźne zdjęcie tyłu dowodu rejestracyjnego.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline': 'Tył dowodu rejestracyjnego',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'Tył dowodu rejestracyjnego - przykład',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'Tył dowodu rejestracyjnego',
	'vehicleRegistrationDocument.validationHeadline': 'Brakujące zdjęcia',
	'vehicleRegistrationDocument.validationDescription': 'Dodaj następujące zdjęcia:',
	'landing.stepDescription.vehicleRegistrationDocument': 'Zrób zdjęcia dowodu rejestracyjnego',
	'review.stepDescription.vehicleRegistrationDocument': 'Dowód rejestracyjny pojazdu',
	'landing.changeLang': 'Aby zmienić język, kliknij tutaj.',
	'chooseLang.headline': 'Wybierz preferowany język',
	'additionalDocuments.additionalDocumentImages': 'Zdjęcia dodatkowych dokumentów',
	'additionalDocuments.headline.first': 'Dodatkowe dokumenty',
	'additionalDocuments.headline.second':
		'Dodaj zdjęcia dodatkowych dokumentów (np. oświadczenia sprawcy kolizji, notatki z policji, umowy kupna pojazdu oraz innych dokumentów własności) - jeżeli nie zostały one sporządzone naciśnij przycisk pomiń.',
	'additionalDocuments.optionalDocumentImages':
		'Opcjonalnie dodaj kolejne zdjęcia dodatkowych dokumentów.',
	'approval.additionalCosts': 'Koszty dodatkowe',
	'approval.button.approve': 'Akceptuję ofertę',
	'approval.button.disapprove': 'Nie akceptuję oferty',
	'approval.calculationPDF': 'Podgląd kalkulacji PDF',
	'approval.description':
		'Sprawdź, czy podany poniżej numer rachunku bankowego jest prawidłowy. Jeśli tak - zatwierdź kosztorys, a powyższa kwota zostanie przelana na Twoje konto.',
	'approval.discount': 'Rabat',
	'approval.headline': 'Wyliczenie kwoty naprawy',
	'approval.labourCosts': 'Robocizna',
	'approval.lacquerCosts': 'Lakierowanie',
	'approval.lacquerMatCosts': 'Materiał lakierniczy',
	'approval.payoutAmount': 'Kwota wypłaty',
	'approval.repairAmount': 'Kwota naprawy netto',
	'approval.repairAmountGross': 'Kwota naprawy brutto',
	'approval.retention': 'Retention',
	'approval.smallCosts': 'Drobne koszty dodatkowe',
	'approval.sparePartCosts': 'Części zapasowe',
	'approval.tax': 'Podatek VAT',
	'blockedByDevice.headline': 'PolicyCheck nie wspiera komputerów',
	'blockedByDevice.description':
		'Strona została otwarta z wykorzystaniem przeglądarki na komputerze.\r\nPlatforma PolicyCheck dedykowana jest do dokumentowania\r\npojazdu za pomocą urządzeń mobilnych.\r\n\r\nUruchom link na urządzeniu mobilnym aby kontynuować.',
	'bodyshop.headline': 'Warsztaty w okolicy',
	'bodyshop.mainError': 'Nie można załadować warsztatów ...',
	'bodyshop.mainLoader.loadingLocation': 'Określanie pozycji ...',
	'bodyshop.mainLoader.loadingWorkshop': 'Ładowanie warsztatów w okolicy ...',
	'button.accept': 'Akceptuj',
	'button.addLater': 'Dodaj później',
	'button.backchangeImage': 'Wroć i zmień zdjęcie',
	'button.call': 'Zadzwoń',
	'button.changeImage': 'Zmień zdjęcie',
	'button.close': 'Zamknij',
	'button.contact': 'Kontakt',
	'button.continue': 'Kontynuuj',
	'button.dataProtection': 'Polityka prywatności',
	'button.deleteImage': 'Usuń zdjęcie',
	'button.help': 'Pomoc',
	'button.imprint': 'Informacje o usłudze',
	'button.liveChat': 'Live-Chat',
	'button.next': 'Dalej',
	'button.ok': 'Ok',
	'button.onApproval': 'Pobieranie kalkulacji',
	'button.onCallback': 'Otrzymano informacje zwrotną',
	'button.onExpertRequest': 'Zapytanie do technika',
	'button.onInsuranceExpert': 'Przeniesienie do technika',
	'button.onLanding': 'Bez przygotowania',
	'button.onOnboarding': 'Przygotowanie',
	'button.onVideocall': 'Kontakt video',
	'button.payout': 'Tak, proszę wypłacić',
	'button.prev': 'Wstecz',
	'button.repair': 'Przeprowadź naprawę',
	'button.select': 'Wybierz',
	'button.selectPhoto': 'Wybierz zdjęcie',
	'button.showTutorial': 'O aplikacji',
	'button.showWhatsApp': 'Wiadomość WhatsApp',
	'button.skip': 'Pomiń',
	'button.start': 'Start',
	'calculationDetailsModal.additionalCosts': 'Koszty dodatkowe',
	'calculationDetailsModal.labourCosts': 'Robocizna',
	'calculationDetailsModal.lacquerCosts': 'Lakierowanie',
	'calculationDetailsModal.spareParts': 'Części zapasowe',
	'calculationDetailsModal.total': 'Razem',
	'callback.description':
		'Niestety nie można było wygenerować kalkulacji dla tej szkody. Skontaktujemy się z Państwem w ciągu 24h w dni robocze w celu omówienia dalszych kroków.',
	'callback.headline': 'Państwa szkoda została przetworzona.',
	'completeDamageDescriptionModal.description': 'Proszę opisać krótko jak doszło do zdarzenia.',
	'completeDamageDescriptionModal.headline': 'Podpowiedź',
	'completeDamageImages.description': 'Dodaj przynajmniej 2 zdjęcia szkód z różnych odległości.',
	'completeDamageImages.headline': 'Porada',
	'completeDashboardMileageModal.dashboardImage': 'Zdjęcie przebiegu',
	'completeDashboardMileageModal.description': 'Proszę dodać poniższe informacje:',
	'completeDashboardMileageModal.hasValidMileage': 'Przebieg pojazdu',
	'completeDashboardMileageModal.headline': 'Podpowiedź',
	'completeAdditionalDocuments.headline': 'Porada',
	'completeAdditionalDocuments.description':
		'Dodaj zdjęcia dodatkowych dokumentów lub naciśnij przycisk Pomiń.',
	'completeFourAdditionalPicturesModal.description': 'Proszę dodać poniższe informacje:',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Zdjęcie przebiegu',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage':
		'Zdjęcie deski rozdzielczej pojazdu',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Zdjęcie numeru VIN pojazdu',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Zdjęcie przedniej szyby pojazdu',
	'completeFourAdditionalPicturesModal.headline': 'Podpowiedź',
	'completeOverallDashboardImageModal.description': 'Dodaj następujące informacje:',
	'completeOverallDashboardImageModal.hasOverallDashboardImage': 'Zdjęcie deski rozdzielczej',
	'completeOverallDashboardImageModal.headline': 'Podpowiedź',
	'completePayoutInformationModal.accountHolder': 'Właściciel konta',
	'completePayoutInformationModal.accountHolderIBAN': 'Numer konta właściciela',
	'completePayoutInformationModal.accountHolderIBANInvalid': 'Poprawny numer konta właściciela',
	'completePayoutInformationModal.description': 'Proszę dodać następujące informacje:',
	'completePayoutInformationModal.headline': 'Podpowiedź',
	'completePoliceReportModal.description': 'Proszę dodać poniższe informacje:',
	'completePoliceReportModal.hasAccidentOnAlcoholOrDrugs':
		'Czy był/była Pan/Pani pod wpływem alkoholu lub innych środków odurzających w chwili zdarzenia?',
	'completePoliceReportModal.hasAccidentOwnFault': 'Czy jest Pan/Pani sprawcą zdarzenia?',
	'completePoliceReportModal.hasDamageDescription': 'Opis uszkodzeń',
	'completePoliceReportModal.hasPoliceInformed': 'Czy została zawiadomiona policja?',
	'completePoliceReportModal.hasPoliceReportExists': 'Czy jest raport policyjny?',
	'completePoliceReportModal.headline': 'Podpowiedź',
	'completeVehicleImagesModal.description': 'Proszę dodać następujące informacje:',
	'completeVehicleImagesModal.hasVehicleImageFront': 'Zdjęcie przodu pojazdu',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Zdjęcie pojazdu z przodu z lewej strony',
	'completeVehicleImagesModal.hasVehicleImageFrontRight':
		'Zdjęcie pojazdu z przodu z prawej strony',
	'completeVehicleImagesModal.hasVehicleImageLeft': 'Zdjęcie lewej strony pojazdu ',
	'completeVehicleImagesModal.hasVehicleImageRear': 'Zdjęcie tyłu pojazdu',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Zdjęcie pojazdu tyłu z lewej strony',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Zdjęcie pojazdu z tyłu z prawej strony',
	'completeVehicleImagesModal.hasVehicleImageRight': 'Zdjęcie prawej strony pojazdu',
	'completeVehicleImagesModal.headline': 'Podpowiedź',
	'completeVehicleInformationModal.dashboardImage': 'Zdjęcie przebiegu',
	'completeVehicleInformationModal.description': 'Proszę dodać poniższe informacje:',
	'completeVehicleInformationModal.hasValidMileage': 'Przebieg pojazdu',
	'completeVehicleInformationModal.headline': 'Podpowiedź',
	'completeVehicleInformationModal.isRegistrationDocument2Uploaded':
		'Zdjęcie dowodu rejestracyjnego (tył)',
	'completeVehicleInformationModal.isRegistrationDocumentUploaded':
		'Zdjęcie dowodu rejestracyjnego',
	'completeVinModal.description': 'Proszę dodać następujące informacje:',
	'completeVinModal.hasVin': 'Zdjęcie zawierające nr VIN',
	'completeVinModal.headline': 'Podpowiedź',
	'completeWindshieldImageModal.description': 'Dodaj następujące informacje:',
	'completeWindshieldImageModal.hasWindshieldImage': 'Zdjęcie przedniej szyby',
	'completeWindshieldImageModal.headline': 'Wskazówka',
	'connectionError.description': 'Błąd połączenia. Prosimy wysłać zdjęcie ponownie.',
	'connectionError.title': 'Błąd połączenia',
	'damageDescription.button.back': '« Powrót',
	'damageDescription.button.help': 'Pomoc',
	'damageDescription.button.next': 'Dalej »',
	'damageDescription.headline.first': 'Opis okoliczności zdarzenia',
	'damageDescription.paragraph.first': 'Opisz krótko, jak doszło do uszkodzenia pojazdu',
	'damageDescription.placeholder':
		'Przykładowo: Na skrzyżowaniu inny pojazd uderzył przodem w lewy bok mojego samochodu. Mój przedni lewy błotnik został wgnieciony.',
	'damageImages.additionalImages': 'Dodatkowe zdjęcia uszkodzeń',
	'damageImages.description':
		'Dodaj co najmniej 2 zdjęcia każdego z uszkodzeń pojazdu. Prosimy o zdjęcia z różnych perspektyw (przybliżenie / cały element). Ważne: uszkodzenie musi być widoczne.',
	'damageImages.headline': 'Zdjęcia uszkodzeń',
	'damageImages.optionalDamageImages':
		'Opcjonalnie dodaj kolejne zdjęcia dokumentujące uszkodzenia.',
	'damageImages.photo': 'Zdjęcie uszkodzenia',
	'damageImagesExampleModal.headline': 'Zdjęcia uszkodzeń - przykład',
	'dashboardImageExampleModal.headline': 'Zdjęcie deski rozdzielczej - przykład',
	'dashboardMileage.dashboard.paragraph':
		'Dodaj zdjęcie deski rozdzielczej z wyświetlonym przebiegiem. Jeśli Państwa pojazd posiada wyświetlacze elektroniczne prosimy o ich włączenie.',
	'dashboardMileage.dashboard.title': 'Zdjęcie przebiegu',
	'dashboardMileage.headline.first': 'Przebieg',
	'dashboardMileage.paragraph.first': 'Podaj przebieg pojazdu.',
	'dashboardMileage.paragraph.mileageAutoFilled':
		'Przebieg został uzupełniony automatycznie na podstawie zdjęcia. Proszę sprawdzić, czy wartość jest poprawna',
	'dashboardMileage.placeholder': 'np. 150000 km',
	'dataPrivacyModal.headline': 'Warunki korzystania',
	'editPhoto.edit': 'Zmień',
	enumeration: '{position, select, first {} last { i } other {, }}{enumeration}',
	'feedback.button.send': 'Wyślij opinię',
	'feedback.comment.placeholder': 'Dodaj komentarz',
	'feedback.description':
		'Mamy nadzieję, że jesteś zadowolony z naszych usług i czekamy na Twoją opinię.',
	'feedback.headline': 'Dziękujemy za wykorzystanie EasyClaim!',
	'feedback.headline.policyCheck': 'Dziękujemy za wykorzystanie PolicyCheck!',
	'feedback.rating': 'Jak ocenią Państwo usługę przetwarzania szkód w EasyClaim?',
	'feedback.rating.policyCheck': 'Jak ocenią Państwo usługę przetwarzania szkód w PolicyCheck?',
	'feedback.yourOpinion': 'Twoja opinia',
	'fourAdditionalPictures.mileage.description':
		'Prosimy zrobić zdjęcie przebiegu. Jeśli masz elektroniczny drogomierz, włącz wyświetlacz.',
	'fourAdditionalPictures.mileage.enter': 'Wprowadź przebieg pojazdu',
	'fourAdditionalPictures.mileage.title': 'Przebieg',
	'mismatchModal.enteredMileage': 'Przebieg',
	'fourAdditionalPictures.overallDashboard.description': 'Zrób zdjęcie całej deski rozdzielczej.',
	'fourAdditionalPictures.overallDashboard.title': 'Deska rozdzielcza',
	'fourAdditionalPictures.title': 'Dodatkowe zdjęcia',
	'fourAdditionalPictures.vin.description':
		'Proszę zrobić zdjęcie VIN pojazdu. Możesz go znaleźć na krawędzi drzwi lub w lewym dolnym rogu przedniej szyby.',
	'fourAdditionalPictures.vin.title': 'VIN',
	'fourAdditionalPictures.windshield.description':
		'Proszę szczegółowo sfotografować przednią szybę pojazdu.',
	'fourAdditionalPictures.windshield.title': 'Przednia szyba pojazdu',
	'fourAdditionalPicturesExampleModal.button.close': 'Zamknij',
	'fourAdditionalPicturesExampleModal.headline.first': 'Dodatkowe zdjęcia',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Przykładowe zdjęcia',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Przykładowe zdjęcia',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Przykładowe zdjęcia',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Przykładowe zdjęcia',
	'fourDiagonalPerspectives.vehicleFrontRight.title': ' ',
	'fourDiagonalPerspectives.vehicleRearRight.title': ' ',
	'fourDiagonalPerspectives.vehicleRearLeft.title': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle': 'Przykładowe zdjęcia',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'Przykładowe zdjęcia',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle': 'Przykładowe zdjęcia',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle': 'Przykładowe zdjęcia',
	'fourPerspectivesExampleModal.button.close': 'Zamknij',
	'fourPerspectivesExampleModal.headline.first': 'Zdjęcia poglądowe pojazdu – przykład',
	'helpModal.description':
		'Nie możesz przejść któregoś kroku, albo masz pytania? Skontaktuj się z nami! Chętnie Ci pomożemy:',
	'helpModal.headline': 'Pomoc',
	'imageRecognitionFeedback.isDamageVisible.infoText':
		'Upewnij się, że załączone zdjęcie przedstawia <b>uszkodzenia</b> i kontynuuj.',
	'imageRecognitionFeedback.isDamageVisible.title': 'Uszkodzenie',
	'imageRecognitionFeedback.isDamageVisible.titleWarning': 'Uszkodzenie',
	'imageRecognitionFeedback.isFrontLeftPerspectiveVisible.infoText':
		'Upewnij się, że perspektywa <b>ukośna - lewy przód</b> pojazdu jest w pełni widoczna i kontynuuj.',
	'imageRecognitionFeedback.isFrontLeftPerspectiveVisible.title': 'Ukośne z przodu',
	'imageRecognitionFeedback.isFrontPerspectiveVisible.infoText':
		'Upewnij się, że perspektywa <b>ukośna z przodu</b> pojazdu jest w pełni widoczna i kontynuuj.',
	'imageRecognitionFeedback.isFrontPerspectiveVisible.title': 'Ukośne z przodu',
	'imageRecognitionFeedback.isRearPerspectiveVisible.infoText':
		'Upewnij się, że perspektywa <b>ukośna z tyłu</b> pojazdu jest w pełni widoczna i kontynuuj.',
	'imageRecognitionFeedback.isRearPerspectiveVisible.title': 'Ukośne z tyłu',
	'imageRecognitionFeedback.isRearPerspectiveVisible.titleWarning': 'Ukośne z tyłu',
	'imageRecognitionFeedback.isRearRightPerspectiveVisible.infoText':
		'Upewnij się, że perspektywa <b>ukośna - prawy tył</b> pojazdu jest w pełni widoczna i kontynuuj.',
	'imageRecognitionFeedback.isRearRightPerspectiveVisible.title': 'Ukośne z tyłu',
	'imageRecognitionFeedback.isRearRightPerspectiveVisible.titleWarning': 'Ukośne z tyłu',
	'imageRecognitionFeedback.isVinVisible.infoText':
		'Upewnij się, że załączone zdjęcie przedstawia numer <b>VIN</b> i kontynuuj.',
	'imageRecognitionFeedback.isVinVisible.title': 'Zdjęcie z widocznym numerem VIN',
	'imageRecognitionFeedback.isVinVisible.titleWarning': 'Zdjęcie z widocznym numerem VIN',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Przykładowe zdjęcia',
	'imageRecognitionMismatchModal.headline': 'Czy jesteś pewien, że dodałeś właściwe zdjęcie?',
	'impactDirections.description': 'Impact Directions Description',
	'impactDirections.title': 'Impact Directions Title',
	'impactDirections.button.next': 'Oferta',
	'insuranceExpert.description':
		'Dziękujemy bardzo. Państwa szkoda została przetworzona. Wkrótce skontaktujemy się z Państwem w celu określenia dalszych kroków.',
	'insuranceExpert.headline': 'Wkrótce skontaktujemy się z Państwem.',
	'label.details': 'Szczegóły',
	'landing.aboutEasyclaim': 'Czym jest EasyClaim?',
	'landing.aboutPolicyCheck': 'Czym jest PolicyCheck?',
	'landing.dataPrivacyLink': ' Przetwarzanie i ochrona danych osobowych',
	'landing.headline': 'Wycena szkody w kilku krokach:',
	'landing.headline.policyCheck': 'Inspekcja samochodu w kilku krokach:',
	'landing.paragraph': ' ',
	'landing.stepDescription.additionalDocuments': 'Dodaj zdjęcie oświadczenia sprawcy',
	'landing.stepDescription.damageDescription': 'Opisz uszkodzenia',
	'landing.stepDescription.damageImages': 'Zrób zdjęcia uszkodzeń',
	'landing.stepDescription.feedback': 'Podziel się swoją opinią',
	'landing.stepDescription.fourAdditionalPictures': 'Prześlij zdjęcia',
	'landing.stepDescription.fourDiagonalPerspectives': 'Zrób wymagane zdjęcia',
	'landing.stepDescription.vehicleImages': 'Zrób zdjęcia poglądowe pojazdu',
	'landing.stepDescription.vehicleInformation': 'Dane pojazdu',
	'landing.stepDescription.vinPicture': 'Dodaj zdjęcie numeru VIN znajdującego się na pojeździe',
	'landing.termsAndConditionsLink': 'Zaakceptuj regulamin',
	'landing.termsAndConditionsLinkDescription':
		'Aby rozpocząć, zaakceptuj regulamin i kliknij Dalej.',
	'loader.error': 'Szkoda nie może zostać załadowana. Proszę spróbować później...',
	'loader.loading': 'Ładowanie danych ...',
	'mainError.tryAgain': 'Spróbuj ponownie',
	'mainMenu.contact': 'Skontaktuj się z nami',
	'mainMenu.contact.officeHours': 'Godziny wsparcia: Poniedziałek - Piątek 7:00 - 17:00',
	'mainMenu.contactDescription': 'Czy mają Państwa pytania? Prosimy telefon: {hotlineNumber}',
	'mainMenu.dataPrivacy': 'Polityka prywatności',
	'mainMenu.description': 'Kliknij na przycisk, aby przeczytać politykę prywatności.',
	'mainMenu.headline': 'Polityka prywatności',
	'mainMenu.imprintDescription': 'Kliknij w przycisk, aby otworzyć informacje o usłudze.',
	'mainMenu.imprintLink': 'Informacje o usłudze',
	'necessaryDocuments.bankAccountExample.description':
		'Przykładowy:82 1020 0000 0000 0000 0000 0001',
	'necessaryDocuments.bankAccountExample.headline': 'Numer konta bankowego',
	'necessaryDocuments.damageImages.description':
		'Przygotuj przynajmniej 2 zdjęcia uszkodzeń z różnych perspektyw',
	'necessaryDocuments.damageImages.headline': 'Zdjęcia z uszkodzeniami',
	'necessaryDocuments.dashboardImage.description': 'Przykład zdjęcia deski rozdzielczej',
	'necessaryDocuments.dashboardImage.headline': 'Zdjęcie deski rozdzielczej',
	'necessaryDocuments.headline.first': 'Potrzebne dokumenty',
	'necessaryDocuments.paragraph.first':
		'A wykorzystać aplikację EasyClaim będziesz musiał przygotować następujące zdjęcia: ',
	'necessaryDocuments.registrationDocument.description': 'Zdjęcie dowodu rejestracyjnego (przód)',
	'necessaryDocuments.registrationDocument.description_inner':
		'Zdjęcie dowodu rejestracyjnego (tył)',
	'necessaryDocuments.registrationDocument.headline': 'Zdjęcia dowodu rejestracyjnego',
	'necessaryDocuments.statementImageExample.description':
		'Np. przypadku kolizji oświadczenie sprawcy kolizji',
	'necessaryDocuments.statementImageExample.headline': 'Zdjęcia dokumentów dodatkowych',
	'necessaryDocuments.vehicleImages.description': 'Przykładowe zdjęcia poglądowe',
	'necessaryDocuments.vehicleImages.headline': 'Zdjęcia poglądowe pojazdu',
	'necessaryDocuments.vinImage.description': 'Przykład zdjęcia numeru VIN',
	'necessaryDocuments.vinImage.headline': 'Zdjęcie numeru VIN',
	'onboarding.button.finish': 'Uruchom »',
	'onboarding.button.next': 'Dalej »',
	'onboarding.headline.first': 'Zrób zdjęcia uszkodzeń',
	'onboarding.headline.second': 'Kalkulacja',
	'onboarding.headline.third': 'Pobierz kalkulację',
	'onboarding.link.dataPrivacy': 'Akceptuję politykę prywatności',
	'onboarding.link.skip': 'Dalej',
	'onboarding.paragraph.first': 'Technik wykorzysta zdjęcia, aby wycenić szkodę.',
	'onboarding.paragraph.second': 'Proszę wgrać zdjęcia tablicy rejestracyjnej oraz uszkodzeń.',
	'onboarding.paragraph.third':
		'W ciągu kilku godzin otrzymacie Państwo kalkulację. Następnie mogą Państwo zdecydować czy wypłacić kwotę czy naprawić pojazd w warsztacie ',
	'overallDashboardImage.description': 'Proszę zrobić zdjęcie deski rozdzielczej',
	'overallDashboardImage.headline': 'Całościowe zdjęcie deski rozdzielczej',
	'overallDashboardImage.title': 'Całościowe zdjęcie deski rozdzielczej',
	'overallDashboardImageExampleModal.button.close': 'Zamknij',
	'overallDashboardImageExampleModal.headline.first': 'Zdjęcie deski rozdzielczej - przykład',
	'payout.button.back': '« Powrót',
	'payout.button.help': 'Pomoc',
	'payout.button.payoutConfirm': 'Potwierdź wypłatę »',
	'payout.headline.first': 'Numer konta',
	'payout.headline.second': 'Właściciel konta',
	'payout.headline.third': 'Numer  konta',
	'payout.paragraph': 'Prosimy o podanie numeru rachunku bankowego do wypłaty odszkodowania.',
	'perspective.front.left': 'przód z lewej strony',
	'perspective.front.right': 'przód z prawej strony',
	'perspective.rear.left': 'tył z lewej strony',
	'perspective.rear.right': 'tył z prawej strony',
	'registrationDocumentExampleModal.headline': 'Zdjęcie dowodu rejestracyjnego - przykład',
	'resolverequest.button.continue': 'Wyślij odpowiedź',
	'resolverequest.headline': 'Dodatkowe informacje wymagane',
	'resolverequest.onload': 'Ładowanie sprawy...',
	'resolverequest.onload.error': 'Błąd podczas ładowania sprawy. Proszę spróbować później.',
	'resolverequest.perspective.paragraph':
		'Sfotografuj swój pojazd po przekątnej z przodu z lewej strony i z tyłu z prawej strony. Tablica rejestracyjna musi być czytelna. Zdjęcia są potrzebne, aby uzyskać ocenić ogólny stan pojazdu i porównać numer tablicy rejestracyjnej z dowodem rejestracyjnym pojazdu.',
	'resolverequest.question.headline': 'Mamy pytanie',
	'review.button.back': '« Powrót',
	'review.button.close': 'Zakończ »',
	'review.button.help': 'Pomoc',
	'review.button.next': 'Dalej',
	'review.editViewButton': 'Podgląd / Edycja',
	'review.headline.first': 'Sprawdź',
	'review.paragraph.first':
		'Upewnij się, że wszystkie dane zostały wprowadzone, następnie kliknij "Zakończ". Otrzymasz podsumowanie wprowadzonych danych.',
	'review.stepDescription.additionalDocuments': 'Dodatkowe dokumenty',
	'review.stepDescription.damageDescription': 'Opis uszkodzeń',
	'review.stepDescription.damageImages': 'Zdjęcia uszkodzeń',
	'review.stepDescription.mileage': 'Przebieg',
	'review.stepDescription.vehicleFrontPerspectiveImage': 'Zdjęcia przodu pojazdu',
	'review.stepDescription.vehicleImages': 'Zdjęcia pojazdu',
	'review.stepDescription.vehicleInformation': 'Dane pojazdu',
	'review.stepDescription.vehicleLeftPerspectiveImage': 'Zdjęcia lewej strony pojazdu',
	'review.stepDescription.vehicleRearPerspectiveImage': 'Zdjęcia tyłu pojazdu',
	'review.stepDescription.vehicleRightPerspectiveImage': 'Zdjęcia prawej strony pojazdu',
	'review.stepDescription.vinPicture': 'Zdjęcie nr VIN',
	'review.stepDescription.windshield': 'Zdjęcie szyby czołowej',
	'review.stepDescription.fourAdditionalPictures': 'Dodatkowe zdjęcia',
	'review.stepDescription.fourDiagonalPerspectives': 'Zdjęcia perspektyw',
	'thanks.calculationPDF': 'Podgląd kalkulacji PDF',
	'thanks.headline.first': 'Dziękujemy',
	'thanks.paragraph.first': 'Dziękujemy za użycie aplikacji!',
	'thanksForFeedback.headline.first': 'Dziękujemy za Twoją opinię!',
	'thanksForFeedback.paragraph.first':
		'Twoja opinia o naszym serwisie jest dla nas bardzo ważna.Stale pracujemy nad ulepszeniem EasyClaim, a Twoja opinia jest ważna dla naszego sukcesu.',
	'timeout.bottom': ' ',
	'timeout.headline.first': 'Link do aplikacji przestał być aktywny!',
	'tooManyAttempts.description':
		'Niestety przekroczyłeś limit maksymalnej liczby otwartych sesji. Nasi konsultanci skontaktują się z Tobą później.',
	'tooManyAttempts.title': 'Przekroczyłeś limit sesji',
	'tutorialModal.headline.first': 'Czym jest EasyClaim?',
	'tutorialModal.headline.first.policyCheck': 'Czym jest PolicyCheck?',
	'tutorialModal.paragraph.first':
		'Easy Claim jest to nowoczesna aplikacja umożliwiająca szybkie udokumentowanie i wycenę uszkodzeń pojazdu. Sztuczna inteligencja wspiera wykonanie zdjęć, które pozwalają ekspertowi wyliczenie kosztorysu naprawy oraz przedstawienie oferty rozliczenia szkody. Dzięki zastosowaniu nowoczesnych technologii skracamy czas obsługi Twojej szkody do minimum.',
	'tutorialModal.paragraph.first.policyCheck':
		'PolicyCheck to szybka inspekcja pojazdu. Proces oględzin składa się z 8 prostych kroków.',
	'tutorialModal.paragraph.second':
		'Wszystkie te okoliczności pozwalają nam przedstawić Ci realistyczny kosztorys w tak krótkim czasie.',
	'upload.message':
		'Dane są wgrywane. W zależności od szybkości połączenia internetowego ten proces może trwać do kilku minut.',
	'vehicleImages.backOverview': 'Zdjęcie z tyłu pojazdu',
	'vehicleImages.description': 'Zrób zdjęcia zgodnie z instrukcją.',
	'vehicleImages.details.first': 'Przód pojazdu',
	'vehicleImages.details.fourth': 'Lewy bok pojazdu',
	'vehicleImages.details.frontleft':
		'Dodaj zdjęcie samochodu, na którym widoczny będzie cały przód i lewy bok pojazdu wraz z przednią tablicą rejestracyjną.',
	'vehicleImages.details.rearright':
		'Dodaj zdjęcie samochodu, na którym widoczny będzie cały tył i prawy bok pojazdu wraz z tylną tablicą rejestracyjną.',
	'vehicleImages.details.second': 'Prawy bok pojazdu',
	'vehicleImages.details.third': 'Tył pojazdu',
	'vehicleImages.frontOverview': 'Zdjęcie z przodu pojazdu',
	'vehicleImages.leftFrontOverview': 'Zdjęcie z przodu z lewej strony',
	'vehicleImages.leftOverview': 'Zdjęcie z lewej strony pojazdu',
	'vehicleImages.leftRearOverview': 'Zdjęcie ukośne tyłu - lewa strona',
	'vehicleImages.overviewPhotos': 'Zdjęcia poglądowe pojazdu',
	'vehicleImages.overviewPhotos.subtitle': 'Sfotografuj pojazd',
	'vehicleImages.rightFrontOverview': 'Zdjęcie ukośne z przodu - prawa strona',
	'vehicleImages.rightOverview': 'Zdjęcie prawej strony pojazdu',
	'vehicleImages.rightRearOverview': 'Zdjęcie z tyłu z prawej strony',
	'vehicleImagesExampleModal.button.close': 'Zamknij',
	'vehicleImagesExampleModal.headline.first': 'Zdjęcia poglądowe pojazdu – przykład',
	'vehicleInformation.button.back': '« Powrót',
	'vehicleInformation.button.help': 'Pomoc',
	'vehicleInformation.button.next': 'Dalej »',
	'vehicleInformation.headline.first': 'Informacje nt. pojazdu',
	'vehicleInformation.headline.fourth': 'Zdjęcie dowodu rejestracyjnego (tył)',
	'vehicleInformation.headline.second': 'Zdjęcie dowodu rejestracyjnego (przód)',
	'vehicleInformation.paragraph.first': 'Dodaj zdjęcie dowodu rejestracyjnego pojazdu (przód)',
	'vehicleInformation.paragraph.fourth': 'Dodaj zdjęcie dowodu rejestracyjnego pojazdu (tył)',
	'vinImagesExampleModal.button.close': 'Zamknij',
	'vinImagesExampleModal.headline.first': 'Zdjęcie zawierające nr VIN – przykład',
	'vinPicture.description': 'Zrób zdjęcie nr VIN na pojeździe',
	'vinPicture.headline': 'Zdjęcie zawierające numer VIN',
	'vinPicture.title': 'Zdjęcie nr VIN',
	'waitForAudit.callBack': 'Jeżeli mają Państwa pytania, chętnie Państwu pomożemy:',
	'waitForAudit.description': ' ',
	'waitForAudit.description.damageFound':
		'Dziękujemy za przesłanie dokumentacji. Nasz ekspert przygotuje wycenę szkody w ciągu maksymalnie 1 dnia roboczego, o wynikach poinformujemy odrębnym sms-em i/lub emailem.',
	'waitForAudit.description.damageNotFound':
		'Dziękujemy za przesłanie dokumentacji. Nasz ekspert przygotuje wycenę szkody w ciągu maksymalnie 1 dnia roboczego, o wynikach poinformujemy odrębnym sms-em i/lub emailem.',
	'waitForAudit.thankYou': 'Dziękujemy!',
	'waitforAudit.finish': 'Zakończ',
	'windshieldExampleModal.button.close': 'Zamknij',
	'windshieldExampleModal.headline.first': 'Zdjęcie przedniej szyby - przykład',
	'windshieldImage.description': 'Proszę zrobić zdjęcie przedniej szyby',
	'windshieldImage.headline': 'Zdjęcie przedniej szyby',
	'windshieldImage.title': 'Zdjęcie przedniej szyby',
	'withoutPayout.description':
		'Chciałbyś naprawić pojazd? Z przyjemnością pomożemy w wyborze wykwalifikowanego warsztatu w Twojej okolicy.',
	'withoutPayout.footer': 'Skontaktujemy się z Tobą jak najszybciej, aby omówić dalszą procedurę.',
	'withoutPayout.headline': 'Z przyjemnością wesprzemy Cię!',

	'testcasemodal.headline': 'Uwaga - sprawa testowa!',
	'testcasemodal.accept': 'Akceptuj',
	'testcasemodal.paragraph': 'Uwaga - sprawa testowa!',
	'testcasewarningalert.paragraph': 'Sprawa testowa!',

	'additionaldamagewarningalert.paragraph':
		'Ze względu na możliwe uszkodzenia pojazdu dokumentacja zostanie przeanalizowana ręcznie.',

	'image.locked.RegistrationDocument':
		'Z uwagi na ochronę danych osobowych, pobieranie zdjęć dowodu rejestracyjnego zostało zablokowane.',
	'image.locked.RegistrationDocumentInside':
		'Z uwagi na ochronę danych osobowych, pobieranie zdjęć dowodu rejestracyjnego zostało zablokowane.',
	'image.locked.DniInside':
		'Z uwagi na ochronę danych osobowych, pobieranie zdjęć dowodu osobistego zostało zablokowane.',
	'image.locked.DniOutside':
		'Z uwagi na ochronę danych osobowych, pobieranie zdjęć dowodu osobistego zostało zablokowane.',
	'image.locked.VehicleDatasheetInside':
		'Z uwagi na ochronę danych osobowych, pobieranie zdjęć karty pojazdu zostało zablokowane.',
	'image.locked.VehicleDatasheetOutside':
		'Z uwagi na ochronę danych osobowych, pobieranie zdjęć karty pojazdu zostało zablokowane.',
	'image.locked.DriverLicenseInside':
		'Z uwagi na ochronę danych osobowych, pobieranie zdjęć prawa jazdy zostało zablokowane.',
	'image.locked.DriverLicenseOutside':
		'Z uwagi na ochronę danych osobowych, pobieranie zdjęć prawa jazdy zostało zablokowane.',

	'missingPhoto.title': 'Brakujące zdjęcie',
	'missingPhoto.description':
		'Wygląda na to, że brakuje zdjęcia. Proszę dodać zdjęcie, aby kontynuować.',

	'invalidFile.size.title': 'Nieprawidłowy rozmiar zdjęcia',
	'invalidFile.size.description': 'Zdjęcie jest większe niż maksymalny dozwolony rozmiar.',
	'invalidFile.extension.title': 'Nieobsługiwany typ pliku',
	'invalidFile.extension.description':
		'Podany typ pliku nie jest obsługiwany. Obsługiwane typy plików: .jpg, .jpeg, .jfif, .heic, .heif, .png oraz .bmp',

	'camera.darkWarning':
		'Otoczenie potencjalnie zbyt ciemne — popraw oświetlenie w celu uzyskania lepszej jakości zdjęcia.',
	'serviceErrorModal.headline': 'Unexpected error occured',
	'serviceErrorModal.close': 'OK',

	'serviceErrorModal.paragraph.first': 'Unexpected error has occured, please reload the page.',
	'serviceErrorModal.paragraph.second': 'If the error is persistent, reach out for support.',
	'serviceErrorModal.paragraph.details':
		'Please share any additional detail (e.g., screenshot) that could help us reproduce the error.',
};

export default messages;
